<div>
  @if (extract.configList && extract.configList.length > 0) {

    <div class="filter-section-label">{{'ui.charts.config' | translate}}</div>
    @for (conf of extract.configList; track conf) {
<mat-form-field class="w-100" floatLabel="always">
      <mat-label>{{ conf.label | translate }}</mat-label>
      <mat-select
                  [ngModel]="extract.config[conf.key]"
                  (ngModelChange)="setConfig(conf.key, $event)">
        @for (choice of conf.choices; track choice) {
<mat-option [value]="choice.value">{{choice.label | label | async}}</mat-option>
}
      </mat-select>
    </mat-form-field>
}
  
}

  @if (extract.filters && extract.filters.length > 0) {

    <div class="filter-section-label">{{ 'ui.charts.filters' | translate }}</div>

    @for (fil of extract.filters; track fil) {
<mat-form-field class="w-100" floatLabel="always">
      <mat-label>{{ fil.label | translate }}</mat-label>
      <mat-select
                  [ngModel]="extract.filter.get(fil.key)"
                  (ngModelChange)="setFilter(fil.key, $event)"
                  [multiple]="fil.multiple"
                  [compareWith]="fil.compareWith ? fil.compareWith : defaultCompare">
        @for (choice of fil.choices; track choice) {
<mat-option [value]="choice.value">{{choice.label | translate }}</mat-option>
}
      </mat-select>
    </mat-form-field>
}
  
}

  @if (canChangeType) {
<mat-form-field class="w-100" floatLabel="always">
    <mat-label>{{ 'filters.chartType.title' | translate }}</mat-label>
    <mat-select [ngModel]="currentType" (ngModelChange)="onChangeType($event)">
      @for (type of chartTypes; track type) {
<mat-option [value]="type">
        <fa-icon [icon]="getTypeIcon(type)"></fa-icon>
        {{ 'filters.chartType.values.' + type | translate }}
      </mat-option>
}
    </mat-select>
  </mat-form-field>
}
</div>
